import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('SafetyCheckFactory', ['$http', 'settings', function ($http, settings) {    
    var safetyCheckUrl = settings.ApiURL + settings.SafetyCheckURL;
    var deviceUrl = settings.ApiURL + settings.DeviceURL;
    var masterDataUrl = settings.ApiURL + settings.MasterDataURL;
    var productUrl = settings.ApiURL + settings.ProductURL;
    var vehicleUrl = settings.ApiURL + settings.VehicleURL;
    return {        
        getSafetyCheckGroup: function () {
            return $http.get(safetyCheckUrl + "/safetycheckgroup");
        },
        getSafetyCheckForLogin: function (companyid, vehicletypeid, dataareaid, vehicleid) {
            return $http.get(safetyCheckUrl + "/safetycheckforlogin/" + companyid + "/" + vehicletypeid + "/" + dataareaid + "/" + vehicleid);
        },
        getNewSafetyCheckForLogin: function (companyid, vehicletypeid, dataareaid, vehicleid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/login/" + companyid + "/" + vehicletypeid + "/" + dataareaid + "/" + vehicleid)
        },
        getSafetyCheckForLogout: function (companyid, vehicletypeid, dataareaid, vehicleid) {
            return $http.get(safetyCheckUrl + "/safetycheckforlogout/" + companyid + "/" + vehicletypeid + "/" + dataareaid + "/" + vehicleid);
        },
        getNewSafetyCheckForLogout: function (companyid, vehicletypeid, dataareaid, vehicleid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/logout/" + companyid + "/" + vehicletypeid + "/" + dataareaid + "/" + vehicleid)
        },
        getSafetyCheckForCustomer: function (companyid, customertypeid) {
            return $http.get(safetyCheckUrl + "/safetycheckforcustomer/" + companyid + "/" + customertypeid);
        },
        getNewSafetyCheckForCustomer: function (companyid, customertypeid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/customer/" + companyid + "/" + customertypeid);
        },
        getSafetyCheckForProduct: function (companyid, producttypeid) {
            return $http.get(safetyCheckUrl + "/safetycheckforproduct/" + companyid + "/" + producttypeid);
        },
        getSafetyCheckForLoadingProduct: function (companyid, producttypeid) {
            return $http.get(safetyCheckUrl + "/safetycheckforloadingproduct/" + companyid + "/" + producttypeid);
        },
        getNewSafetyCheckForProduct: function (companyid, producttypeid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/product/" + companyid + "/" + producttypeid);
        },
        getSafetyCheckForOthers: function (companyid, grouptypeid) {
            return $http.get(safetyCheckUrl + "/safetycheckforothers/" + companyid + "/" + grouptypeid);
        },
        getNewSafetyCheckForOthers: function (companyid, grouptypeid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/others/" + companyid + "/" + grouptypeid);
        },
        getSafetyCheckForVehicleInspection: function (companyid, vehicletypeid) {
            return $http.get(safetyCheckUrl + "/safetycheckforvehicleinspection/" + companyid + "/" + vehicletypeid);
        },
        getNewSafetyCheckForVehicleInspection: function (companyid, vehicletypeid) {
            return $http.get(safetyCheckUrl + "/newsafetycheck/vehicleinspection/" + companyid + "/" + vehicletypeid)
        },
        getVehicleType: function () {
            return $http.get(vehicleUrl + "/vehicletypes/0");
        },
        getDevices: function (companyId) {
            return $http.get(deviceUrl + "/" + companyId);
        },
        getCustomerType: function () {
            return $http.get(masterDataUrl + "/customertypes/0");
        },
        getProductTypes: function () {
            return $http.get(productUrl + "/producttype/dropdown");
        },
        getSafetyGlobalMandatoryStates: function () {
            return $http.get(safetyCheckUrl + "/globalmandatorystates");
        },
        getSafetyMandatoryStates: function () {
            return $http.get(safetyCheckUrl + "/mandatorystates");
        },
        saveSafetyCheckForLogin: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforlogin", safetycheck)
        },
        saveSafetyCheckForLogout: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforlogout", safetycheck)
        },
        saveSafetyCheckForCustomer: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforcustomer", safetycheck)
        },
        saveSafetyCheckForProduct: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforproduct", safetycheck)
        },
        saveSafetyCheckForLoadingProduct: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforloadingproduct", safetycheck)
        },
        saveSafetyCheckForOthers: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforothers", safetycheck)
        },
        saveSafetyCheckForVehicleInspection: function (safetycheck) {
            return $http.put(safetyCheckUrl + "/savesafetycheckforvehicleinspection", safetycheck)
        },
        deleteSafetyCheck: function (companyid, textid, safetygroupid) {
            return $http.delete(safetyCheckUrl + "/deletesafetycheck/" + companyid + "/" + textid + "/" + safetygroupid);
        },
    };
}]);

app.controller('SafetyCheckController', ['$q', '$scope', 'SafetyCheckFactory', 'DataAreaFactory', 'CompanyFactory', '$rootScope', '$state', 'settings', '$filter', 'masterFactory',
                            function ($q, $scope, SafetyCheckFactory, DataAreaFactory, CompanyFactory, $rootScope, $state, settings, $filter, masterFactory) {
    $rootScope.pageTitle = "Safety Checks";
    $scope.safetyCheckCompanies = [];
    $scope.safetyCheckTextGroups = [];
    $scope.vehicleTypes = [];
    $scope.dataAreas = [];
    $scope.customerTypes = [];
    $scope.productTypes = [];
    $scope.devices = [];
    $scope.filteredDevices = null;
    $scope.selectedDevice = {};
    $scope.safetyChecks = null;
    $scope.safetyCheck = {};
    $scope.resetsafetyCheck = {};
    $scope.globalMandatoryStates = [];
    $scope.mandatoryStates = [];
    $scope.error = "";
    $scope.isSafetyCheckLogoutFormVisible = false;
    $scope.isSafetyCheckLoginFormVisible = false;
    $scope.isSafetyCheckCustomerFormVisible = false;
    $scope.isSafetyCheckProductFormVisible = false;
    $scope.isSafetyCheckOthersFormVisible = false;
    $scope.isSafetyCheckVehicleInspectionFormVisible = false;
    $scope.isAddNewTextVisible = false;
    $scope.isRowSelected = false;
    $scope.submitted = false;
    $scope.formHeader = {};
    $scope.formTopMargin = "";
    var mandatoryGlobalImg = "Content/Images/Icons/mandatory-global-24-black.png";
    var notvisibleImg = "Content/Images/Icons/notvisible-24-black.png";
    var optionalImg = "Content/Images/Icons/optional-24-yellow.png";
    var mandatoryImg = "Content/Images/Icons/mandatory-24-red.png";
    var disabledImg = "Content/Images/Icons/disabled-24-grey.png";


    // Initialization - this runs on load
    var init = function () {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([            
            CompanyFactory.getCompanyDropDown(0).success(function (data) {
                $scope.safetyCheckCompanies = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            SafetyCheckFactory.getSafetyCheckGroup().success(function (data) {
                $scope.safetyCheckTextGroups = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            SafetyCheckFactory.getSafetyGlobalMandatoryStates().success(function (data) {
                $scope.globalMandatoryStates = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            SafetyCheckFactory.getSafetyMandatoryStates().success(function (data) {
                $scope.mandatoryStates = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
            $('#loadingModal').modal('hide');
        });
    };

    init();

    // Grid renderers
    $scope.refreshDeviceGrid = function (pageIndex, datasource) {
        $('#gridDevices').dxDataGrid({
            dataSource: datasource,
            noDataText: "No Devices Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '250px',
            selection: { mode: 'single' },
            sorting: { mode: 'single' },
            paging: { pagesize: 5 },
            scrolling: { mode: 'standard' },           
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'Device Id - Name', dataField: 'Id', cssClass: 'Id', dataType: 'string', alignment: 'center', width: '60%',
                   cellTemplate: function (container, options) {
                       var devicedetails = "";
                       if (options.data.Id != 0) devicedetails = devicedetails + options.data.Id + " - ";
                       if (options.data.Name != null) devicedetails = devicedetails + options.data.Name;
                       $('<span />').text(devicedetails).append("</br>").appendTo(container);                       
                   },
                   calculateCellValue: function(data){
                       return data.DeviceId + " - " + data.DeviceName;
                   },
                   calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                       return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                   }
               },

               { caption: 'License plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string', alignment: 'center', width: '40%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.LicensePlate)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {                
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.selectedDevice = selectedRowsInfo.selectedRowsData[0];
                    //$scope.safetyCheck.VehicleTypeId = $scope.selectedDevice.VehicleTypeId;
                    //$scope.safetyCheck.DataAreaId = $scope.selectedDevice.DataAreaId;
                    $scope.safetyCheck.VehicleId = $scope.selectedDevice.VehicleId;
                    $scope.getSafetyChecks();
                }
                else {
                    $scope.safetyCheck.VehicleId = null;
                }
            }
        });
    };

    $scope.refreshSafetyCheckLoginGrid = function (pageIndex) {
        $('#gridSafetyCheckLogin').dxDataGrid({            
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Login Safety Check Texts Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },            
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '40%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center', allowFiltering: false,
                   allowSorting: false, width: '10%', 
                   cellTemplate: function (container, options) {                       
                       $('<img />')                           
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }                   
               },
               {
                   caption: 'Fleet', dataField: 'MandatoryForFleetImage', cssClass: 'MandatoryForFleetImage', dataType: 'string', alignment: 'center', allowFiltering: false,
                   allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Vehicle type', dataField: 'MandatoryForVehicleTypeImage', cssClass: 'MandatoryForVehicleTypeImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Data area', dataField: 'MandatoryForDataAreaImage', cssClass: 'MandatoryForDataAreaImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Device', dataField: 'MandatoryForVehicleImage', cssClass: 'MandatoryForVehicleImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckLogin = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.safetyCheck.selectedSafetyCheckLogin.VehicleTypeId = (IsUndefinedOrNull($scope.safetyCheck.VehicleTypeId) == true) ? null : $scope.safetyCheck.VehicleTypeId;
                    $scope.safetyCheck.selectedSafetyCheckLogin.DataAreaId = (IsUndefinedOrNull($scope.safetyCheck.DataAreaId) == true) ? null : $scope.safetyCheck.DataAreaId;
                    $scope.safetyCheck.selectedSafetyCheckLogin.VehicleId = (IsUndefinedOrNull($scope.safetyCheck.VehicleId) == true) ? null : $scope.safetyCheck.VehicleId;
                    $scope.isSafetyCheckLoginFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Login - Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.safetyCheck.selectedSafetyCheckLogin = null;
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckLoginFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForFleet == 0 && rowInfo.data.MandatoryForVehicleType == 0
                    && rowInfo.data.MandatoryForDataArea == 0 && rowInfo.data.MandatoryForVehicle == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    });
                }
                $('#gridSafetyCheckLogin td').each(function () {
                    if ($(this)[0].cellIndex == 4 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 5 && $scope.safetyCheck.DataAreaId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 6 && $scope.safetyCheck.VehicleId == undefined)
                        $(this).css('opacity', '0.4');
                });
                rowElement.find('td').each(function () {
                    if ($(this)[0].cellIndex == 4 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 5 && $scope.safetyCheck.DataAreaId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 6 && $scope.safetyCheck.VehicleId == undefined)
                        $(this).css('opacity', '0.4');
                });
            }
        });
    };

    $scope.refreshSafetyCheckLogoutGrid = function (pageIndex) {
        $('#gridSafetyCheckLogout').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Logout Safety Check Texts Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '40%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Fleet', dataField: 'MandatoryForFleetImage', cssClass: 'MandatoryForFleetImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Vehicle type', dataField: 'MandatoryForVehicleTypeImage', cssClass: 'MandatoryForVehicleTypeImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Data area', dataField: 'MandatoryForDataAreaImage', cssClass: 'MandatoryForDataAreaImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Device', dataField: 'MandatoryForVehicleImage', cssClass: 'MandatoryForVehicleImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckLogout = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.safetyCheck.selectedSafetyCheckLogout.VehicleTypeId = (IsUndefinedOrNull($scope.safetyCheck.VehicleTypeId) == true) ? null : $scope.safetyCheck.VehicleTypeId;
                    $scope.safetyCheck.selectedSafetyCheckLogout.DataAreaId = (IsUndefinedOrNull($scope.safetyCheck.DataAreaId) == true) ? null : $scope.safetyCheck.DataAreaId;
                    $scope.safetyCheck.selectedSafetyCheckLogout.VehicleId = (IsUndefinedOrNull($scope.safetyCheck.VehicleId) == true) ? null : $scope.safetyCheck.VehicleId;
                    $scope.isSafetyCheckLogoutFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Logout - Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.safetyCheck.selectedSafetyCheckLogout = null;
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckLogoutFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForFleet == 0 && rowInfo.data.MandatoryForVehicleType == 0
                    && rowInfo.data.MandatoryForDataArea == 0 && rowInfo.data.MandatoryForVehicle == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    });
                }
                $('#gridSafetyCheckLogout td').each(function () {
                    if ($(this)[0].cellIndex == 4 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 5 && $scope.safetyCheck.DataAreaId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 6 && $scope.safetyCheck.VehicleId == undefined)
                        $(this).css('opacity', '0.4');
                });
                rowElement.find('td').each(function () {
                    if ($(this)[0].cellIndex == 4 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 5 && $scope.safetyCheck.DataAreaId == undefined)
                        $(this).css('opacity', '0.4');
                    if ($(this)[0].cellIndex == 6 && $scope.safetyCheck.VehicleId == undefined)
                        $(this).css('opacity', '0.4');
                });
            }
        });
    };

    $scope.refreshSafetyCheckVehicleInspectionGrid = function (pageIndex) {
        $('#gridSafetyCheckVehicleInspection').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Vehicle Inspection Safety Check Texts Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '40%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center', allowFiltering: false,
                   allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Vehicle type', dataField: 'MandatoryForVehicleTypeImage', cssClass: 'MandatoryForVehicleTypeImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '10%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckVehicleInspection = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.safetyCheck.selectedSafetyCheckVehicleInspection.VehicleTypeId = (IsUndefinedOrNull($scope.safetyCheck.VehicleTypeId) == true) ? null : $scope.safetyCheck.VehicleTypeId;
                    $scope.isSafetyCheckVehicleInspectionFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Login - Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.safetyCheck.selectedSafetyCheckVehicleInspection = null;
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckVehicleInspectionFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForVehicleType == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    });
                }
                $('#gridSafetyCheckVehicleInspection td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
                rowElement.find('td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.VehicleTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
            }
        });
    };

    $scope.refreshSafetyCheckCustomerGrid = function (pageIndex) {
        $('#gridSafetyCheckCustomer').dxDataGrid({            
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Customer Safety Check Texts Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '50%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
        
               },
               {
                   caption: 'Customer type', dataField: 'MandatoryForCustomerTypeImage', cssClass: 'MandatoryForCustomerTypeImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                        $('<img />')
                            .attr('src', 'assets/' + options.value)
                            .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckCustomer = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.safetyCheck.selectedSafetyCheckCustomer.CustomerTypeId = (IsUndefinedOrNull($scope.safetyCheck.CustomerTypeId) == true) ? null : $scope.safetyCheck.CustomerTypeId;                    
                    $scope.isSafetyCheckCustomerFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Customer - Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.safetyCheck.selectedSafetyCheckCustomer = null;
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckCustomerFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForCustomerType == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    })
                }
                $('#gridSafetyCheckCustomer td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.CustomerTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
                rowElement.find('td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.CustomerTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
            }
        });
    };

    $scope.refreshSafetyCheckProductGrid = function (pageIndex) {
        $('#gridSafetyCheckProduct').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Product Safety Check Texts Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '50%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Product type', dataField: 'MandatoryForProductTypeImage', cssClass: 'MandatoryForProductTypeImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckProduct = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.safetyCheck.selectedSafetyCheckProduct.ProductTypeId = (IsUndefinedOrNull($scope.safetyCheck.ProductTypeId) == true) ? null : $scope.safetyCheck.ProductTypeId;
                    $scope.isSafetyCheckProductFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Product - Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.safetyCheck.selectedSafetyCheckProduct = null;
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckProductFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForProductType == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    })
                }
                $('#gridSafetyCheckProduct td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.ProductTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
                rowElement.find('td').each(function () {
                    if ($(this)[0].cellIndex == 3 && $scope.safetyCheck.ProductTypeId == undefined)
                        $(this).css('opacity', '0.4');
                });
            }
        });
    };

    $scope.refreshSafetyCheckOthersGrid = function (pageIndex) {
        $('#gridSafetyCheckOthers').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.safetyChecks,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Safety Check Texts Found for the Group",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: '500px',
            selection: { mode: 'single' },
            scrolling: { mode: 'standard' },
            filterRow: { visible: true },
            groupPanel: { visible: false },
            columns: [
               {
                   caption: 'ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: '10%'
               },
               {
                   caption: 'Text', dataField: 'Text', cssClass: 'Text', dataType: 'string', alignment: 'center', width: '50%',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Text)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Mandatory', dataField: 'MandatoryGlobalImage', cssClass: 'MandatoryGlobalImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               },
               {
                   caption: 'Fleet', dataField: 'MandatoryForOthersImage', cssClass: 'MandatoryForOthersImage', dataType: 'string', alignment: 'center',
                   allowFiltering: false, allowSorting: false, width: '20%',
                   cellTemplate: function (container, options) {
                       $('<img />')
                           .attr('src', 'assets/' + options.value)
                           .appendTo(container);
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.safetyCheck.selectedSafetyCheckOthers = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.resetsafetyCheck = angular.copy(selectedRowsInfo.selectedRowsData[0]);
                    $scope.isSafetyCheckOthersFormVisible = true;
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    $scope.isAddNewTextVisible = false;
                    $scope.isRowSelected = true;
                    $scope.formHeader = "Safety Check Text";
                    ToggleYellowToGreen();
                }
                else {
                    $scope.resetsafetyCheck = null;
                    $scope.isSafetyCheckOthersFormVisible = false;
                    $scope.isFormVisible = false;
                    $scope.isDeleteVisible = false;
                    $scope.isAddNewTextVisible = true;
                    $scope.isRowSelected = false;
                }
            },
            rowPrepared: function (rowElement, rowInfo) {
                if (rowInfo.data.MandatoryForOthers == 0) {
                    rowElement.find('td').each(function () {
                        if ($(this)[0].cellIndex != 2)
                            $(this).css('opacity', '0.4');
                    })
                }
            }
        });
    };

    // On Selection change events
    $scope.companyChanged = function () {
        if ($scope.safetyCheck.SafetyCheckGroupId != null && $scope.safetyCheck.SafetyCheckGroupId == 1) {
            SafetyCheckFactory.getDevices($scope.safetyCheck.SafetyCheckCompanyId).success(function (data) {
                $scope.devices = data;
                $scope.refreshDeviceGrid(0, $scope.devices);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else {
            $scope.getSafetyChecks();
        }
    };

    $scope.safetyCheckGroupChanged = function (groupId) {
        $scope.isAddNewTextVisible = true;
        $scope.isSafetyCheckLoginFormVisible = false;
        $scope.isSafetyCheckLogoutFormVisible = false;
        $scope.isSafetyCheckCustomerFormVisible = false;
        $scope.isSafetyCheckProductFormVisible = false;
        $scope.isSafetyCheckOthersFormVisible = false;
        $scope.isSafetyCheckVehicleInspectionFormVisible = false;
        $scope.isFormVisible = false;
        $scope.isRowSelected = false;
        $scope.safetyCheck.selectedSafetyCheckLogin = null;
        $scope.safetyCheck.selectedSafetyCheckLogout = null;
        $scope.safetyCheck.selectedSafetyCheckCustomer = null;
        $scope.safetyCheck.selectedSafetyCheckProduct = null;
        $scope.safetyCheck.selectedSafetyCheckOthers = null;
        $scope.safetyCheck.selectedSafetyCheckVehicleInspection = null;

        try {
            $('#gridDevices').dxDataGrid('instance').clearSelection();
        }
        catch (error) { }

        if (groupId == 1 || groupId == 11 || groupId == 12) { // get vehicle types and data area
            $scope.safetyCheck.VehicleTypeId = null;
            $scope.safetyCheck.DataAreaId = null;
            $scope.safetyCheck.VehicleId = null;
            $scope.safetyCheck.ProductTypeId = null;
            $scope.safetyCheck.CustomerTypeId = null;

            if ($scope.vehicleTypes != null) {
                SafetyCheckFactory.getVehicleType().success(function (data) {
                    $scope.vehicleTypes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
            if ($scope.dataAreas != null) {
                DataAreaFactory.getDataAreaList(1).success(function (data) {
                    $scope.dataAreas = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
            SafetyCheckFactory.getDevices($scope.safetyCheck.SafetyCheckCompanyId).success(function (data) {
                $scope.devices = data;
                $scope.refreshDeviceGrid(0,$scope.devices);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
            $scope.formTopMargin = {'position':'relative', 'top':'310px'};
        }        
        else if (groupId == 2) { // get customertypes
            $scope.safetyCheck.VehicleTypeId = null;
            $scope.safetyCheck.DataAreaId = null;
            $scope.safetyCheck.VehicleId = null;
            $scope.safetyCheck.ProductTypeId = null;
            
            if ($scope.customerTypes != null) {
                SafetyCheckFactory.getCustomerType().success(function (data) {
                    $scope.customerTypes = $filter('filter')(data, function (item) {
                        return item.Id != 1;
                    });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
            $scope.formTopMargin = { 'position': 'relative', 'top': '207px' };
        }
        else if (groupId == 5 || groupId == 13) { // get producttypes
            $scope.safetyCheck.VehicleTypeId = null;
            $scope.safetyCheck.DataAreaId = null;
            $scope.safetyCheck.VehicleId = null;
            $scope.safetyCheck.CustomerTypeId = null;

            if ($scope.productTypes != null) {
                SafetyCheckFactory.getProductTypes().success(function (data) {
                    $scope.productTypes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
            $scope.formTopMargin = { 'position': 'relative', 'top': '207px' };
        }
        else if (groupId == 7 || groupId == 8 || groupId == 9 || groupId == 10) { // others
                $scope.safetyCheck.VehicleTypeId = null;
                $scope.safetyCheck.DataAreaId = null;
                $scope.safetyCheck.VehicleId = null;
                $scope.safetyCheck.CustomerTypeId = null;
                $scope.safetyCheck.ProductTypeId = null;

                $scope.formTopMargin = { 'position': 'relative', 'top': '158px' };
            }
        $scope.getSafetyChecks();
    };

    $scope.vehicleTypeDataAreaChanged = function () {        
        if ($scope.safetyCheck.VehicleTypeId != null) {
            if ($scope.safetyCheck.DataAreaId != null && $scope.safetyCheck.DataAreaId != 0) {
                $scope.filteredDevices = $filter('filter')($scope.devices, { VehicleTypeId: $scope.safetyCheck.VehicleTypeId, DataAreaId: $scope.safetyCheck.DataAreaId });
            }
            else {
                $scope.filteredDevices = $filter('filter')($scope.devices, { VehicleTypeId: $scope.safetyCheck.VehicleTypeId });
            }
            $scope.refreshDeviceGrid(0, $scope.filteredDevices);
        }
        $scope.getSafetyChecks();
    };

    $scope.customerTypeChanged = function () {
        $scope.getSafetyChecks();
    };

    $scope.productTypeChanged = function () {
        $scope.getSafetyChecks();
    };

    $scope.getSafetyChecks = function () {
        var companyid = $scope.safetyCheck.SafetyCheckCompanyId;
        var vehicletypeid = $scope.safetyCheck.VehicleTypeId;
        var dataareaid = $scope.safetyCheck.DataAreaId;
        var vehicleid = $scope.safetyCheck.VehicleId;
        var dataGrid;
        
        if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
            SafetyCheckFactory.getSafetyCheckForLogin(companyid, vehicletypeid, dataareaid, vehicleid).success(function (data) {
                $scope.safetyChecks = data;                
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckLogin').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckLoginGrid(0);                    
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckLoginGrid(0);
                }                
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });            
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
            SafetyCheckFactory.getSafetyCheckForLogout(companyid, vehicletypeid, dataareaid, vehicleid).success(function (data) {
                $scope.safetyChecks = data;
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckLogout').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckLogoutGrid(0);
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckLogoutGrid(0);
                }
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
            SafetyCheckFactory.getSafetyCheckForVehicleInspection(companyid, vehicletypeid).success(function (data) {
                $scope.safetyChecks = data;
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckVehicleInspection').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckVehicleInspectionGrid(0);
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckVehicleInspectionGrid(0);
                }
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
            var customertypeid = $scope.safetyCheck.CustomerTypeId;
            SafetyCheckFactory.getSafetyCheckForCustomer($scope.safetyCheck.SafetyCheckCompanyId, customertypeid).success(function (data) {
                $scope.safetyChecks = data;
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckCustomer').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckCustomerGrid(0);
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckCustomerGrid(0);
                }                
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 5) {
            var producttypeid = $scope.safetyCheck.ProductTypeId;
            SafetyCheckFactory.getSafetyCheckForProduct($scope.safetyCheck.SafetyCheckCompanyId, producttypeid).success(function (data) {
                $scope.safetyChecks = data;
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckProduct').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckProductGrid(0);
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckProductGrid(0);
                }
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 13) {
            var producttypeid = $scope.safetyCheck.ProductTypeId;
            SafetyCheckFactory.getSafetyCheckForLoadingProduct($scope.safetyCheck.SafetyCheckCompanyId, producttypeid).success(function (data) {
                $scope.safetyChecks = data;
                if ($scope.isRowSelected) {
                    // code to get id of the row selected. 
                    dataGrid = $('#gridSafetyCheckProduct').dxDataGrid('instance');
                    var selectedRow = dataGrid.getSelectedRowsData();
                    $scope.refreshSafetyCheckProductGrid(0);
                    // code to reselect the record after refreshing the grid.                    
                    (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
                }
                else {
                    $scope.refreshSafetyCheckProductGrid(0);
                }
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
            || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
            SafetyCheckFactory.getSafetyCheckForOthers($scope.safetyCheck.SafetyCheckCompanyId, $scope.safetyCheck.SafetyCheckGroupId).success(function (data) {
            $scope.safetyChecks = data;
            if ($scope.isRowSelected) {
                // code to get id of the row selected. 
                dataGrid = $('#gridSafetyCheckOthers').dxDataGrid('instance');
                var selectedRow = dataGrid.getSelectedRowsData();
                $scope.refreshSafetyCheckOthersGrid(0);
                // code to reselect the record after refreshing the grid.                    
                (dataGrid as unknown as FacnmDx).selectRows([selectedRow[0].Id], false);
            }
            else {
                $scope.refreshSafetyCheckOthersGrid(0);
            }
        })
        .error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
        }
    };

    // Button click functions and submit form function
    $scope.submitForm = function () {
        if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForLogin($scope.safetyCheck.selectedSafetyCheckLogin)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for login successfully' });                    
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForLogout($scope.safetyCheck.selectedSafetyCheckLogout)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for logout successfully' });
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForVehicleInspection($scope.safetyCheck.selectedSafetyCheckVehicleInspection)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for vehicle inspection successfully' });
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForCustomer($scope.safetyCheck.selectedSafetyCheckCustomer)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for customer successfully' });                    
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 5) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForProduct($scope.safetyCheck.selectedSafetyCheckProduct)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for product successfully' });                    
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 13) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForLoadingProduct($scope.safetyCheck.selectedSafetyCheckProduct)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details for loading product successfully' });                    
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
            || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
            if ($scope.safetyCheckTextForm.$valid) {
                SafetyCheckFactory.saveSafetyCheckForOthers($scope.safetyCheck.selectedSafetyCheckOthers)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Safety check details successfully' });
                    $scope.cancelForm();
                    $scope.getSafetyChecks();
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.safetyCheckTextForm.submitted = false;
            } else {
                $scope.safetyCheckTextForm.submitted = true;
            }
        }
    };

    $scope.addNewSafetyCheck = function () {        
        var companyid = $scope.safetyCheck.SafetyCheckCompanyId;
        if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
            $scope.formHeader = "Login - Safety Check Text";
            var vehicletypeid = $scope.safetyCheck.VehicleTypeId;
            var dataareaid = $scope.safetyCheck.DataAreaId;
            var vehicleid = $scope.safetyCheck.VehicleId;
            SafetyCheckFactory.getNewSafetyCheckForLogin(companyid, vehicletypeid, dataareaid, vehicleid).success(function (data) {
                $scope.safetyCheck.selectedSafetyCheckLogin = data;
                $scope.resetsafetyCheck = angular.copy(data);
                $scope.refreshSafetyCheckLoginGrid(0);
                $scope.isSafetyCheckLoginFormVisible = true;                
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
            $scope.formHeader = "Logout - Safety Check Text";
            var vehicletypeid = $scope.safetyCheck.VehicleTypeId;
            var dataareaid = $scope.safetyCheck.DataAreaId;
            var vehicleid = $scope.safetyCheck.VehicleId;
            SafetyCheckFactory.getNewSafetyCheckForLogout(companyid, vehicletypeid, dataareaid, vehicleid).success(function (data) {
                $scope.safetyCheck.selectedSafetyCheckLogout = data;
                $scope.resetsafetyCheck = angular.copy(data);
                $scope.refreshSafetyCheckLogoutGrid(0);
                $scope.isSafetyCheckLogoutFormVisible = true;
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
            $scope.formHeader = "Vehicle Inspection - Safety Check Text";
            var vehicletypeid = $scope.safetyCheck.VehicleTypeId;
            var vehicleid = $scope.safetyCheck.VehicleId;
            SafetyCheckFactory.getNewSafetyCheckForVehicleInspection(companyid, vehicletypeid).success(function (data) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection = data;
                $scope.resetsafetyCheck = angular.copy(data);
                $scope.refreshSafetyCheckVehicleInspectionGrid(0);
                $scope.isSafetyCheckVehicleInspectionFormVisible = true;
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
            $scope.formHeader = "Customer - Safety Check Text";
            var companyid = $scope.safetyCheck.SafetyCheckCompanyId;
            var customertypeid = $scope.safetyCheck.CustomerTypeId;
            SafetyCheckFactory.getNewSafetyCheckForCustomer(companyid, customertypeid).success(function (data) {
                $scope.safetyCheck.selectedSafetyCheckCustomer = data;
                $scope.resetsafetyCheck = angular.copy(data);
                $scope.refreshSafetyCheckCustomerGrid(0);
                $scope.isSafetyCheckCustomerFormVisible = true;
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 5 || $scope.safetyCheck.SafetyCheckGroupId == 13) {
            $scope.formHeader = "Product - Safety Check Text";
            var companyid = $scope.safetyCheck.SafetyCheckCompanyId;
            var productypeid = $scope.safetyCheck.ProductTypeId;
            SafetyCheckFactory.getNewSafetyCheckForProduct(companyid, productypeid).success(function (data) {
                $scope.safetyCheck.selectedSafetyCheckProduct = data;
                $scope.resetsafetyCheck = angular.copy(data);
                $scope.refreshSafetyCheckProductGrid(0);
                $scope.isSafetyCheckProductFormVisible = true;
            })
            .error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
            || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
                $scope.formHeader = "Others - Safety Check Text";
                var companyid = $scope.safetyCheck.SafetyCheckCompanyId;
                var safetyGroupId = $scope.safetyCheck.SafetyCheckGroupId;
            SafetyCheckFactory.getNewSafetyCheckForOthers(companyid, safetyGroupId).success(function (data) {
                    $scope.safetyCheck.selectedSafetyCheckOthers = data;
                    $scope.resetsafetyCheck = angular.copy(data);
                    $scope.refreshSafetyCheckOthersGrid(0);
                    $scope.isSafetyCheckOthersFormVisible = true;
                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
        $scope.isAddNewTextVisible = false;
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        ToggleGreenToYellow();
    };

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.reset = function () {
        if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
            $scope.safetyCheck.selectedSafetyCheckLogin = angular.copy($scope.resetsafetyCheck);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details for login successfully' });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
            $scope.safetyCheck.selectedSafetyCheckLogout = angular.copy($scope.resetsafetyCheck);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details for logout successfully' });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
            $scope.safetyCheck.selectedSafetyCheckVehicleInspection = angular.copy($scope.resetsafetyCheck);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details for vehicle inspection successfully' });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
            $scope.safetyCheck.selectedSafetyCheckCustomer = angular.copy($scope.resetsafetyCheck);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details for customer successfully' });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 5 || $scope.safetyCheck.SafetyCheckGroupId == 13) {
            $scope.safetyCheck.selectedSafetyCheckProduct = angular.copy($scope.resetsafetyCheck);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details for product successfully' });
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
            || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
                $scope.safetyCheck.selectedSafetyCheckOthers = angular.copy($scope.resetsafetyCheck);
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Reset Safety check details successfully' });
            }
    };

    $scope.cancelForm = function () {
        $scope.isAddNewTextVisible = true;
        $scope.isFormVisible = false;
        $scope.isDeleteVisible = false;
        $scope.isRowSelected = false;
        if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
            $scope.isSafetyCheckLoginFormVisible = false;
            $scope.safetyCheck.selectedSafetyCheckLogin = null;
            var dataGrid = $('#gridSafetyCheckLogin').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
            $scope.isSafetyCheckLogoutFormVisible = false;
            $scope.safetyCheck.selectedSafetyCheckLogout = null;
            var dataGrid = $('#gridSafetyCheckLogout').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
            $scope.isSafetyCheckVehicleInspectionFormVisible = false;
            $scope.safetyCheck.selectedSafetyCheckVehicleInspection = null;
            var dataGrid = $('#gridSafetyCheckVehicleInspection').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
            $scope.isSafetyCheckCustomerFormVisible = false;
            $scope.safetyCheck.selectedSafetyCheckCustomer = null;
            var dataGrid = $('#gridSafetyCheckCustomer').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 5 || $scope.safetyCheck.SafetyCheckGroupId == 13) {
            $scope.isSafetyCheckProductFormVisible = false;
            $scope.safetyCheck.selectedSafetyCheckProduct = null;
            var dataGrid = $('#gridSafetyCheckProduct').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
            || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
                $scope.isSafetyCheckOthersFormVisible = false;
                $scope.safetyCheck.selectedSafetyCheckOthers = null;
                var dataGrid = $('#gridSafetyCheckOthers').dxDataGrid('instance');
                dataGrid.clearSelection();
            }
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            $scope.isAddNewTextVisible = true;
            $scope.isFormVisible = false;
            $scope.isDeleteVisible = false;
            $scope.isRowSelected = false;
            if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
                var companyid = $scope.safetyCheck.selectedSafetyCheckLogin.CompanyId;
                var textid = $scope.safetyCheck.selectedSafetyCheckLogin.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                    .success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details for login successfully' });                        
                        $scope.getSafetyChecks();
                    })
                    .error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                $scope.isSafetyCheckLoginFormVisible = false;
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
                var companyid = $scope.safetyCheck.selectedSafetyCheckLogout.CompanyId;
                var textid = $scope.safetyCheck.selectedSafetyCheckLogout.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                    .success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details for logout successfully' });
                        $scope.getSafetyChecks();
                    })
                    .error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                $scope.isSafetyCheckLogoutFormVisible = false;
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
                var companyid = $scope.safetyCheck.selectedSafetyCheckVehicleInspection.CompanyId;
                var textid = $scope.safetyCheck.selectedSafetyCheckVehicleInspection.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                    .success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details for vehicle inspection successfully' });
                        $scope.getSafetyChecks();
                    })
                    .error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                $scope.isSafetyCheckVehicleInspectionFormVisible = false;
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 2) {
                var companyid = $scope.safetyCheck.selectedSafetyCheckCustomer.CompanyId;
                var textid = $scope.safetyCheck.selectedSafetyCheckCustomer.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                    .success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details for customer successfully' });                        
                        $scope.getSafetyChecks();
                    })
                    .error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                $scope.isSafetyCheckCustomerFormVisible = false;
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 5 || $scope.safetyCheck.SafetyCheckGroupId == 13) {
                var companyid = $scope.safetyCheck.selectedSafetyCheckProduct.CompanyId;
                var textid = $scope.safetyCheck.selectedSafetyCheckProduct.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                    .success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details for product successfully' });                        
                        $scope.getSafetyChecks();
                    })
                    .error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                $scope.isSafetyCheckProductFormVisible = false;
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 7 || $scope.safetyCheck.SafetyCheckGroupId == 8
                || $scope.safetyCheck.SafetyCheckGroupId == 9 || $scope.safetyCheck.SafetyCheckGroupId == 10) {
                    var companyid = $scope.safetyCheck.selectedSafetyCheckOthers.CompanyId;
                    var textid = $scope.safetyCheck.selectedSafetyCheckOthers.Id;
                SafetyCheckFactory.deleteSafetyCheck(companyid, textid, $scope.safetyCheck.SafetyCheckGroupId)
                        .success(function (data) {
                            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Safety check details successfully' });
                            $scope.getSafetyChecks();
                        })
                        .error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            $('#DeleteModal').modal('hide');
                        });
                    $scope.isSafetyCheckOthersFormVisible = false;
                }
        }
     
    };

    $scope.resetFilterOptions = function () {
        $scope.isFormVisible = false;
        $scope.isDeleteVisible = false;
        $scope.isAddNewTextVisible = false;
        $scope.isRowSelected = false;
        $scope.isSafetyCheckLoginFormVisible = false;
        $scope.isSafetyCheckLogoutFormVisible = false;
        $scope.isSafetyCheckCustomerFormVisible = false;
        $scope.isSafetyCheckProductFormVisible = false;
        $scope.isSafetyCheckVehicleInspectionFormVisible = false;


        $scope.safetyCheck.SafetyCheckCompanyId = null;
        $scope.safetyCheck.SafetyCheckGroupId = null;
        $scope.safetyCheck.VehicleTypeId = null;
        $scope.safetyCheck.DataAreaId = null;
        $scope.safetyCheck.VehicleId = null;
        $scope.safetyCheck.CustomerTypeId = null;
        $scope.safetyCheck.ProductTypeId = null;


        // code to unselect row in different tables. 
        var dataGrid;
        try {
            dataGrid = $('#gridDevices').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckLogin').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckLogout').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckVehicleInspection').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckCustomer').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckProduct').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
        try {
            dataGrid = $('#gridSafetyCheckOthers').dxDataGrid('instance');
            dataGrid.clearSelection();
        }
        catch (error) { }
    };

    // Helping functions and events
    $scope.IsFilterOptionsResetDisabled = function () {
        var isDisabled = true;
        isDisabled = IsUndefinedOrNull($scope.safetyCheck.VehicleTypeId) ? true : false;
        return isDisabled;
    };

    $scope.updateGlobalMandatory = function (GlobalMandatoryState, ObjectType) {
        if (ObjectType == "login") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryGlobalImage = notvisibleImg;
            }
        }
        else if (ObjectType == "logout") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryGlobalImage = notvisibleImg;
            }
        }
        else if (ObjectType == "vehicleinspection") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryGlobalImage = notvisibleImg;
            }
        }
        else if (ObjectType == "customer") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryGlobalImage = notvisibleImg;
            }
        }
        else if (ObjectType == "product") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryGlobalImage = notvisibleImg;
            }
        }
        else if (ObjectType == "others") {
            if (GlobalMandatoryState == 0) {
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryGlobal = 1;
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryGlobalImage = mandatoryGlobalImg;
            }
            else if (GlobalMandatoryState == 1) {
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryGlobal = 0;
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryGlobalImage = notvisibleImg;
            }
        }

    };

    function getNextState(state) {
        if (state == 0) return 1;
        else if (state == 1) return 2;
        else if (state == 2) return 0;
    };

    function getImageUrl(state) {
        if (state == 0) return optionalImg;
        else if (state == 1) return mandatoryImg;
        else if (state == 2) return notvisibleImg;
    };

    $scope.updateMandatoryState = function (MandatoryState, FilterType) {        
        if (FilterType == "fleet") {
            if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForFleet = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForFleetImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForFleet = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForFleetImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForFleet = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForFleetImage = getImageUrl(MandatoryState);
            }
        }
        else if (FilterType == "vehicletype") {
            if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForVehicleType = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForVehicleTypeImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForVehicleType = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForVehicleTypeImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForVehicleType = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForVehicleTypeImage = getImageUrl(MandatoryState);
            }
        }
        else if (FilterType == "dataarea") {
            if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForDataArea = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForDataAreaImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForDataArea = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForDataAreaImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForDataArea = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForDataAreaImage = getImageUrl(MandatoryState);
            }
        }
        else if (FilterType == "vehicle") {
            if ($scope.safetyCheck.SafetyCheckGroupId == 1) {
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForVehicle = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogin.MandatoryForVehicleImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 11) {
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForVehicle = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckLogout.MandatoryForVehicleImage = getImageUrl(MandatoryState);
            }
            else if ($scope.safetyCheck.SafetyCheckGroupId == 12) {
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForVehicle = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckVehicleInspection.MandatoryForVehicleImage = getImageUrl(MandatoryState);
            }
        }
        else if (FilterType == "customertype") {
            $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryForCustomerType = getNextState(MandatoryState);
            $scope.safetyCheck.selectedSafetyCheckCustomer.MandatoryForCustomerTypeImage = getImageUrl(MandatoryState);
        }
        else if (FilterType == "producttype") {            
            $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryForProductType = getNextState(MandatoryState);
            $scope.safetyCheck.selectedSafetyCheckProduct.MandatoryForProductTypeImage = getImageUrl(MandatoryState);            
        }
        else if (FilterType == "others") {
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryForOthers = getNextState(MandatoryState);
                $scope.safetyCheck.selectedSafetyCheckOthers.MandatoryForOthersImage = getImageUrl(MandatoryState);
        }
    };
    
}]);
